import { useMemo } from 'react'
import { useLocation } from 'react-router'

import { detectCurrentRoute } from 'routes/detection'

export const useCurrentRoute = (): ReturnType<typeof detectCurrentRoute> => {
  const { pathname } = useLocation()
  return useMemo(() => detectCurrentRoute(pathname), [pathname])
}
